/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum LocationStatus {
  Invalid="Invalid",
Validated="Validated",
Geocoding="Geocoding"
}

/**
* LocationStatus
*/
export const LocationStatusEnumType = types.enumeration("LocationStatus", [
        "Invalid",
  "Validated",
  "Geocoding",
      ])
